export default __webpack_public_path__ + "static/media/Upload.eb433579.svg";